import { render, staticRenderFns } from "./SchemaCapCubeConfig.vue?vue&type=template&id=24fed001"
import script from "./SchemaCapCubeConfig.vue?vue&type=script&lang=js"
export * from "./SchemaCapCubeConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports